import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const LinkWithParams = ({ to, children, ...rest }) => {
  const [serarchParams] = useSearchParams();

  return (
    <Link to={to + `?${serarchParams}`} {...rest}>
      {children}
    </Link>
  );
};

export default LinkWithParams;
